
<script>
import { required } from 'vuelidate/lib/validators'

import axios from 'axios'

export default {
	props: {
		url: {
			type: String,
			default: '/pan/xdr/assets',
		}
	},
	data() {
		return {
			appConfig: {},
			category: 'List',
			items: [
				{
					text: 'Home',
					href: '/',
				},
				{
					text: 'Assets View',
					active: true,
				},
			],
			appConfig: process.env.NODE_ENV === 'production' ? require('@src/app.config') : require('@src/app.config.dev'),
			incidents: [],
			tableData: [],
			totalRows: 1,
			currentPage: 1,
			perPage: 10,
			pageOptions: [10, 25, 50, 100],
			filter: null,
			filterOn: [],
			sortBy: 'reputation',
			sortDesc: true,
			fields: [
				{ key: 'type', sortable: true },
				{ key: 'reference', label: 'Reference', sortable: true },
				{ key: 'reputation', sortable: true },
				{ key: 'incidents', sortable: true },
				{ key: 'alerts', sortable: true },
				{ key: 'last_update', sortable: true },
			],
			isBusy: true
		}
	},
	validations: {
		event: {
			title: { required },
			category: { required },
		},
	},
	computed: {
		rows() {
			return this.tableData.length
		},
	},
	mounted () {
		this.loadData()
	},
	methods: {
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
		},
		loadData () {
			let that = this
			that.isBusy = true
			let baseURL = that.appConfig.xdrAPI.baseURL || 'http://localhost:5000'
			axios.get(`${baseURL}${that.url}`).then((response) => {
				if (response.status === 200) {
					that.tableData = response.data.map(function(entry){
						return {
							type: entry.type,
							reference: entry.reference,
							reputation: entry.reputation,
							incidents: entry.incidents !== undefined ? entry.incidents.length : 0,
							incidents_high: entry.incidents_high !== undefined ? entry.incidents_high.length : 0,
							incidents_medium: entry.incidents_medium !== undefined ? entry.incidents_medium.length : 0,
							incidents_low: entry.incidents_low !== undefined ? entry.incidents_low.length : 0,
							alerts: entry.alerts !== undefined ? entry.alerts.length : 0,
							alerts_high: entry.alerts_high !== undefined ? entry.alerts_high.length : 0,
							alerts_medium: entry.alerts_medium !== undefined ? entry.alerts_medium.length : 0,
							alerts_low: entry.alerts_low !== undefined ? entry.alerts_low.length : 0,
							last_update: new Date(entry.last_update['$date']).toLocaleString(),
						}
					})
					that.totalRows = that.tableData.length
				}
				that.isBusy = false
			})
			.catch(function (error) {
				if (error.response.status === 401 || error.response.status === 403) {
					localStorage.removeItem('idToken')
					that.$router.push({ name: 'Home' })
				}
			}) 
			that.totalRows = that.tableData.length
		},
	},
}
</script>

<template>
	<div>
		<div class="row mb-md-2">
			<div class="col-sm-6 col-md-6">
				<span>
					Found: 
					<b>
						{{ totalRows }}
					</b>
					at
					<b>
						{{ new Date().toLocaleString() }}
					</b>
				</span>
			</div>

			<div class="col-sm-6 col-md-6">
				<div
					id="tickets-table_filter"
					class="dataTables_filter text-md-right"
				>
					<label class="d-inline-flex align-items-center">
						Search:
						<b-form-input
							v-model="filter"
							type="search"
							placeholder="Search..."
							class="form-control form-control-sm ml-2"
						></b-form-input>
					</label>
				</div>
			</div>
		</div>
		<div class="table-responsive mb-0">
			<b-table
				:items="tableData"
				:fields="fields"
				:busy="isBusy"
				responsive="sm"
				:per-page="perPage"
				:current-page="currentPage"
				:sort-by.sync="sortBy"
				:sort-desc.sync="sortDesc"
				:filter="filter"
				:filter-included-fields="filterOn"
				@filtered="onFiltered"
			>
				<template v-slot:table-busy>
					<div class="text-center">
					<br><br>
					<b-spinner class="align-middle"></b-spinner>
					<strong>&nbsp;&nbsp;Loading...</strong>
					</div>
				</template>
				<template v-slot:cell(type)="data">
					<template v-if="data.item.type === 'host_name'">
						<feather type="monitor" class="icon-xs icon-dual"></feather>
					</template>
					<template v-else-if="data.item.type === 'user_name'">
						<feather type="user" class="icon-xs icon-dual"></feather>
					</template>
				</template>
				<template v-slot:cell(incidents)="data">
					<span class="badge badge-secondary">
						{{ data.item.incidents }}
					</span>
					<span>
						=
					</span>
					<span class="badge badge-danger">
						{{ data.item.incidents_high }}
					</span>
					<span>
						+
					</span>
					<span class="badge badge-warning">
						{{ data.item.incidents_medium }}
					</span>
					<span>
						+
					</span>
					<span class="badge badge-success">
						{{ data.item.incidents_low }}
					</span>
				</template>
				<template v-slot:cell(alerts)="data">
					<span class="badge badge-secondary">
						{{ data.item.alerts }}
					</span>
					<span>
						=
					</span>
					<span class="badge badge-danger">
						{{ data.item.alerts_high }}
					</span>
					<span>
						+
					</span>
					<span class="badge badge-warning">
						{{ data.item.alerts_medium }}
					</span>
					<span>
						+
					</span>
					<span class="badge badge-success">
						{{ data.item.alerts_low }}
					</span>
				</template>
				<template v-slot:cell(action)="data">
					<span>ℹ️</span>
				</template>
			</b-table>
		</div>
		<div class="row">
			<div class="col-sm-12 col-md-6">
				<div id="tickets-table_length" class="dataTables_length">
					<label class="d-inline-flex align-items-center">
						Show&nbsp;
						<b-form-select
							v-model="perPage"
							size="sm"
							:options="pageOptions"
						></b-form-select
						>&nbsp;entries
					</label>
				</div>
			</div>
			<div class="col">
				<div
					class="dataTables_paginate paging_simple_numbers float-right"
				>
					<ul class="pagination pagination-rounded mb-0">
						<b-pagination
							v-model="currentPage"
							:total-rows="totalRows"
							:per-page="perPage"
						></b-pagination>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>
